module.exports = __webpack_public_path__ + "img/c5.8d765c0e.png";